import React, { useState } from 'react';
import styles from './styles.module.scss';
import { Link } from 'react-router-dom';
import logo from './assets/logo.svg';
import { Donate } from '@/features/changeDonate/ui/Donate';
import { t } from 'i18next';
import twitch from './assets/twitch.svg';
import rutube from './assets/rutube.svg';
import vk from './assets/vk.svg';
import dzen from './assets/dzen.svg';
import youtube from './assets/youtube.svg';
import send from './assets/send.svg';
import mail from './assets/mail.svg';
import { AppTooltip } from '@igo/ui';
import { copyToClipbord } from '@/shared/utils';
import { MenuSport } from '../header/ui/MenuSport/MenuSport';
import { MenuGame } from '../header/ui/MenuGame/MenuGame';
import { MenuPublications } from '../header/ui/MenuPublications/MenuPublications';
import ArrowIcon from '../header/assets/ArrowUp.svg?react';
import { useIsMobile } from '@/shared/utils';
import cn from 'classnames';

export const Footer: React.FC = () => {
    const [isOpenTooltip, setIsOpenTooltip] = useState(false);
    const [menuOpen, setMenuOpen] = useState<'game' | 'sport' | 'publications'>();
    const isMobile = useIsMobile(900);
    const handleClickEmail = () => {
        copyToClipbord('support@sputnik-go.com', setIsOpenTooltip);
    };
    const toggleMenu = (menu: 'game' | 'sport' | 'publications') => {
        setMenuOpen((current) => (current === menu ? undefined : menu));
    };
    return (
        <footer className={styles.footer}>
            <div className={styles.topLine}>
                <div className={styles.left}>
                    <Link className={styles.logo} to="/">
                        <span className={styles.LogoTitle}>{t('title').toUpperCase()}</span>
                        <img src={logo} alt="Go Companion" />
                    </Link>
                    <Donate className={styles.donate} />
                </div>
                <div className={styles.pages}>
                    <div className={styles.pageList}>
                        {isMobile ? (
                            <button
                                type="button"
                                className={cn(styles.pageTitle, styles.menuTitleButton)}
                                onClick={() => toggleMenu('sport')}
                                aria-expanded={menuOpen === 'sport'}
                            >
                                {t('menuSport')}
                                <ArrowIcon
                                    className={cn(styles.menuArrow, { [styles.menuArrowOpen]: menuOpen === 'sport' })}
                                />
                            </button>
                        ) : (
                            <span className={styles.pageTitle}>{t('menuSport')}</span>
                        )}
                        <div
                            className={cn(styles.footerSubMenu, {
                                [styles.footerSubMenuClosed]: isMobile && menuOpen !== 'sport',
                            })}
                        >
                            <MenuSport className={styles.menu} />
                        </div>
                    </div>
                    <div className={styles.pageList}>
                        {isMobile ? (
                            <button
                                type="button"
                                className={cn(styles.pageTitle, styles.menuTitleButton)}
                                onClick={() => toggleMenu('game')}
                                aria-expanded={menuOpen === 'game'}
                            >
                                {t('menuGame')}
                                <ArrowIcon
                                    className={cn(styles.menuArrow, { [styles.menuArrowOpen]: menuOpen === 'game' })}
                                />
                            </button>
                        ) : (
                            <span className={styles.pageTitle}>{t('menuGame')}</span>
                        )}
                        <div
                            className={cn(styles.footerSubMenu, {
                                [styles.footerSubMenuClosed]: isMobile && menuOpen !== 'game',
                            })}
                        >
                            <MenuGame className={styles.menu} />
                        </div>
                    </div>
                    <div className={styles.pageList}>
                        {isMobile ? (
                            <button
                                type="button"
                                className={cn(styles.pageTitle, styles.menuTitleButton)}
                                onClick={() => toggleMenu('publications')}
                                aria-expanded={menuOpen === 'publications'}
                            >
                                {t('menuPublications')}
                                <ArrowIcon
                                    className={cn(styles.menuArrow, {
                                        [styles.menuArrowOpen]: menuOpen === 'publications',
                                    })}
                                />
                            </button>
                        ) : (
                            <span className={styles.pageTitle}>{t('menuPublications')}</span>
                        )}
                        <div
                            className={cn(styles.footerSubMenu, {
                                [styles.footerSubMenuClosed]: isMobile && menuOpen !== 'publications',
                            })}
                        >
                            <MenuPublications className={styles.menu} />
                        </div>
                    </div>
                    <Link to="/about" className={styles.pageTitle}>
                        {t('menuAboutCompany')}
                    </Link>
                </div>
                <div className={styles.contacts}>
                    <span className={styles.pageTitle}>{t('contacts')}</span>
                    <span className={styles.email} onClick={handleClickEmail} data-tooltip-id="email">
                        <img src={mail} alt="email" />
                        support@sputnik-go.com
                        <AppTooltip id="email" variant="light" isOpen={isOpenTooltip}>
                            Скопировано
                        </AppTooltip>
                    </span>
                    <a href="https://t.me/GoCompanion" target="_blank">
                        <img src={send} alt="telegram" /> {t('Telegram_ru')}
                    </a>
                    <a href="https://t.me/GoCompanionWorld" target="_blank">
                        <img src={send} alt="telegram" /> {t('Telegram_en')}
                    </a>
                </div>
            </div>
            <div className={styles.bottomLine}>
                <div className={styles.policy}>
                    <a href="/api/v1/docs/SputnikEndUserAgreement.pdf" rel="noopener noreferrer" target="_blank">
                        {t('User_agreement')}
                    </a>
                    <a href="/api/v1/docs/SputnikPersonalConsent.pdf" rel="noopener noreferrer" target="_blank">
                        <span>{t('Privacy_policy')}</span>
                    </a>
                    <a href="/api/v1/docs/SputnikCookiesConsent.pdf" rel="noopener noreferrer" target="_blank">
                        {t('Cookie_policy')}
                    </a>
                </div>
                <div className={styles.support}>
                    <span>{t('footerSupport')}</span>
                </div>
                <div className={styles.social}>
                    <a href="https://www.twitch.tv/sputnikgo" target="_blank">
                        <img src={twitch} alt="twitch" />
                    </a>
                    <a href="https://rutube.ru/channel/80253533/" target="_blank">
                        <img src={rutube} alt="rutube" />
                    </a>
                    <a href="https://vkvideo.ru/@club240610000" target="_blank">
                        <img src={vk} alt="vk" />
                    </a>
                    <a href="https://dzen.ru/id/6a6df85bc6b7334ed9ec9262?share_to=link" target="_blank">
                        <img src={dzen} alt="dzen" />
                    </a>
                    <a href="https://youtube.com/@go-companion" target="_blank">
                        <img src={youtube} alt="youtube" />
                    </a>
                </div>
            </div>
        </footer>
    );
};
